module.exports = __webpack_public_path__ + "assets/measure_odometer.9e6d0ecc.svg";